import React from 'react'
import { Link } from 'react-router-dom'

function Footer() {
    return (
        <footer className="main-footer">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6">
                        <div className="footer-newsletter-box">
                            <div className="footer-newsletter-title">
                                <h3>Don't miss out, subscribe!</h3>
                            </div>
                            <div className="newsletter-form">
                                <form
                                    id="newsletterForm"
                                    action="#"
                                    method="POST"
                                >
                                    <div className="form-group">
                                        <input
                                            type="email"
                                            name="email"
                                            className="form-control"
                                            id="mail"
                                            placeholder="Enter Your Email"
                                            required
                                        />
                                        <button
                                            type="submit"
                                            className="newsletter-btn"
                                        >
                                            <img
                                                src={`${process.env.PUBLIC_URL}/images/arrow-white.svg`}
                                                alt=""
                                            />
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-2 col-md-4 col-6">
                        <div className="footer-links">
                            <h3>company</h3>
                            <ul>
                                <li>
                                    <Link to="/">home</Link>
                                </li>
                                <li>
                                    <Link to="/about">about Us</Link>
                                </li>
                                <li>
                                    <Link to="/services">services</Link>
                                </li>
                                <li>
                                    <Link to="/faqs">FAQs</Link>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className="col-lg-2 col-md-4 col-6">
                        <div className="footer-links">
                            <h3>support</h3>
                            <ul>
                                <li>
                                    <Link to="/contact">Contact us</Link>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className="col-lg-2 col-md-4">
                        <div className="footer-links">
                            <h3>service</h3>
                            <ul>
                                <li>
                                    <Link to="/service-cooperative">
                                        Co-operative Platform
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/service-micro-lending">
                                        Micro-lending
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/service-tax-consulting">
                                        Tax Consulting
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/service-financial-reporting">
                                        Financial Reporting
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className="col-lg-12">
                        <div className="footer-cta-box">
                            <div className="footer-logo">
                                <img
                                    src={`${process.env.PUBLIC_URL}/images/fidelanchor-logo-final.png`}
                                    alt="Logo"
                                />
                            </div>
                            <div className="footer-contact-box">
                                <div className="footer-contact-item">
                                    <p>Need help!</p>
                                    <h3>+234 705 803 0389</h3>
                                    <h3>+234 906 972 4769</h3>
                                </div>
                                <div className="footer-contact-item">
                                    <p>E-mail now</p>
                                    <h3>info@fidelanchor.com</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer
